import {useDispatch} from 'react-redux';
import {useIntl} from 'react-intl';


import cartService from '../../../../services/CartService';

import {cartActions, cartUtils} from '../index';
import {notificationConstants, useToastMessage} from '../../Notification';


/**
 * @returns {(function({cartId: *, cartItems: *}): Promise<void>)|*}
 */
function useRemoveCartItems() {

    const dispatch = useDispatch();
    const {formatMessage} = useIntl();
    const toastMessage = useToastMessage();

    /**
     * @param cartId {string} Cart id to remove items from
     * @param cartItems {object[]} Array of cart items to be removed
     */
    return async (cartId, cartItems) => {

        if (cartItems.length === 0) {

            throw Error('No cart items provided to remove');
        }

        const cartItemIds = cartItems.map(cartItem => cartUtils.itemIdFromData(cartItem));
        const removeResponse = await cartService.removeCartItems(cartId, cartItemIds);

        dispatch(cartActions.onCartLoaded(removeResponse.cart));

        const {deletedItemCount} = removeResponse;
        if (deletedItemCount > 0) {
            toastMessage(
                notificationConstants.NOTIFICATION_TYPE_SUCCESS,
                formatMessage({id: 'notification.cart.delete.success'}, {deletedItemCount})
            );
        }
    };
}


export default useRemoveCartItems;
